import apiCall from "../../../utility/api";

interface FilterValues {
	operator: string;
	value: string | number | string[];
}

type dataProps = {
	setErrorToast: any;
	setToastMessage: any;
	setOverlayOpen: any;
	setIsToast: any;
	func?: any;
	data?: any;
	pageNo?: any;
	jsonData?: any;
	uiData?: any;
	setJsonData?: any;
	setUiData?: any;
	saveBtnClicked?: any;
	editBtnClicked?: any;
	formData?: any;
	setSaveBtnClicked?: any;
	setEditBtnClicked?: any;
	setToastAlertCreate?: any;
	setToastAlertEdit?: any;
	rowID?: any;
	setRowID?: any;
	handleEditData?: any;
	setToastAlertError?: any;
	setToastAlertDelete?: any
	setTotalRecords?: any
	totalRecords?: any
	setTotalPages?: any
	isRefresh?: any
	setIsRefresh?: any
	setExportDetails?: any;
	importedDataInserted?: any
	setSearchVal?: any
	searchVal?: any
	userActivity?: any
	renderToast?: any
	toastAlertError?: any
	filterArray?: any
	isfilter?: boolean
	tenant: string
	exportBtnClicked?: any
	setExportBtnClicked?: any
	setTroubleshooterList?: any
	overlayOpen?: any
	setFormData?: any
	selectedTroubleshooterList?: any
	setSingleTableData?: any
	selectedAsset?: any
	loadTableData?: boolean
	setLoadTableData?: any
	type: string
	dartList: any
	setDartList: any
	selectedRowIdInTable: any
	setSelectedRowIdInTable: any;
	overlayName: string;
	JsonData: any;
	setDeleteDisabled: any;
	setDeleteAsset: any;
	deleteAsset: any;
	setOverlayName: any;
};

export const Asset_event_func: any = (props: dataProps) => {
	const fetchDartList = async () => {
		try {
			const url = props.type === 'asset' ? '/asset/getAssets' : '/event/getEvents';

			const { status, data } = await apiCall(url, undefined);

			if (data && status === 'success') {
				props.setDartList(data);
			}
		} catch (error) {
			console.log("fetchDartList error=", error);
		}
	};

	const getAssetsOrEventsList = async (type: string | null, whereCondition: object, limit: number = 50, offset: number = 0) => {
		props.setLoadTableData(false);

		try {
			let { status, data } = await apiCall(`/${props.type}/getList`, { ...whereCondition, type, limit, offset })
			if (status === 'success') {
				props.func(data)
			} else {
				props.func([]);
			}
		} catch (error) {
			console.error("getAssetsOrEventsList error=", (error as Error).message);
			props.func([]);
		}
	};

	const getExportData = async (condition: object) => {
		try {
			const { status, data } = await apiCall(`/${props.type}/getList`, {
				...condition, // Spread the condition object to pass all expected keys
			});
			if (status === 'success') {
				props.setExportDetails && props.setExportDetails(data);
			}
		} catch (error) {
			console.log("getExportData error=", error);
		}
		props.setExportBtnClicked(false);
	}

	const getAssetsOrEventsListCnt = async (type: string | null, whereCondtion: object) => {
		try {
			let { status, data } = await apiCall(`/${props.type}/getCount`, { ...whereCondtion, type })
			if (status === 'success') {
				props.setTotalRecords(data.totalRecords);
				props.setTotalPages(data.totalPages);
			} else {
				props.setTotalRecords(0);
				props.setTotalPages(1);
			}
		} catch (error) {
			console.error("getAssetsOrEventsListCnt error=", error);
			props.setTotalRecords(0);
			props.setTotalPages(1);
		}
	};

	const getAssetRowDetails = async () => {
		const query = props.selectedAsset;
		const apiUrl = 'https://pinot-nh.unifie.io/sql';
		try {
			const requestBody = {
				sql: query,
				"trace": false,
				"queryOptions": "useMultistageEngine=true"
			};
			const response = await fetch(apiUrl, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify(requestBody),
			});

			const responseData = await response.json();
			if (responseData) {
				const assetData = responseData.resultTable;
				props.setSingleTableData(assetData);
			}
		} catch (error) {
			console.error("getAssetRowDetails error=", (error as Error).message);
		}
	};

	const deleteAssetsOrEventsData = async (id: number) => {
		try {
			const { status, data } = await apiCall(`/${props.type}/delete`, { id, tenant: props.tenant })
			if (status === "success") {
				props.setToastAlertDelete(true);
				props.setLoadTableData(true);
			}
		} catch (error) {
			console.error("deleteAssetsOrEventsData error=", (error as Error).message);
		}

		props.setRowID(null);
		props.setSelectedRowIdInTable([]);
		setTimeout(() => {
			props.setDeleteAsset(false);
			props.setDeleteDisabled(true);
		}, 1000);
	}

	const dateformat = (value: any) => {
		const date = new Date(value);
		const year = date.getFullYear();
		const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
		const day = String(date.getDate()).padStart(2, '0');

		return `${year}-${month}-${day}`;
	}

	// TO CREATE ASSET FUNCTION
	const createAssetOrEvent = async (type: string, formData: any) => {
		
		try {

			if (props.type === 'event') {
				formData.fromDate =formData?.fromDate!==null? dateformat(formData?.fromDate):null;
				formData.toDate = formData?.toDate!==null?dateformat(formData?.toDate):null;
			}

			let { data, status } = await apiCall(`/${props.type}/add`, {
				type: type,
				name: formData.name,
				description: formData.description,
				formData: formData,
				tenant: props.tenant
			});

			if (status === 'success') {
				props.setIsToast(true);
			} else {
				props.setToastMessage(`${formData.name} asset creation failed`);
				props.setErrorToast(true);
			}
		} catch (error) {
			console.log("asset error", error);
			props.setToastMessage(`Error occured while saving ${formData.name} asset`);
			props.setErrorToast(true);
		}

		props?.setFormData({
			name: '',
			description: '',
			jsonData: {}
		});
		props.setOverlayOpen(false);

		setTimeout(() => {
			props.setSaveBtnClicked(false);
			props.setLoadTableData(true);
			props.setOverlayName('');
		}, 1000);
	}

	// TO UPDATE ASSET FUNCTION
	const updateAssetOrEvent = async (id: number, formData: any) => {
		try {

			if (props.type === 'event') {
				formData.fromDate = formData?.fromDate!==null? dateformat(formData?.fromDate): null;
				formData.toDate = formData?.toDate!==null? dateformat(formData?.toDate): null;
			}

			let { data, status } = await apiCall(`/${props.type}/update`, {
				id: id,
				name: formData.name,
				description: formData.description,
				formData: formData,
				tenant: props.tenant
			})

			if (status === 'success') {
				props.setIsToast(true);
			} else {
				props.setToastMessage(`${formData.name} asset updation failed`);
				props.setErrorToast(true);
			}
		} catch (error) {
			console.log("asset error", error);
			props.setToastMessage(`Error occured while updating ${formData.name} asset`);
			props.setErrorToast(true);
		}

		props?.setFormData({
			name: '',
			description: '',
			jsonData: {}
		});
		props.setOverlayOpen(false);
		props.setEditBtnClicked(false);

		setTimeout(() => {
			props.setOverlayName('');
			props.setSaveBtnClicked(false);
			props.setLoadTableData(true);
		}, 1000);
	}

	const getAssetsJosnSchemaData = async () => {
		try {
			const dartId = 2004;
			let { status, data } = await apiCall('/alerts/getSchema', { dartId })
			if (data && status === 'success') {
				var jsonValue = JSON.parse(data?.[0]?.jsonSchema);

				const schema = {
					type: "object",
					properties: {
						conditional: {
							title: "Asset Field",
							items: {
								$ref: "#/definitions/person",
							},
							type: "array",
							minItems: 1,
						},
					},
					definitions: {
						person: {
							title: " ",
							properties: {
								"Select Data Name": {
									type: "string",
									enum: props.dartList.map((data: any) => `${data.dataid}`),
									enumNames: props.dartList.map((data: any) => `${data.dataname}`),
								},
							},
							dependencies: {
								"Select Data Name": {
									oneOf: props.dartList.map((data, index) => {
										const conditionalArrayRef = `#/conditionalArray${index + 1}/person`;

										return {
											properties: {
												"Select Data Name": {
													enum: [`${data.dataid}`],
												},
												conditionals: {
													title: " ",
													items: {
														$ref: conditionalArrayRef,
													},
													type: "array",
													minItems: 1,
												},
											},
										};
									}),
								},
							},
						},
					},
					"LastCondition": {
						"person": {
							"title": "Select the condition",
							"type": "object",
							"properties": {
								"ConditionType": {
									"title": " ",
									"type": "string",
									"enum": [
										"=",
										"!=",
										"like",
										"not like",
										"like start%",
										"like %end"
									],
									"enumNames": [
										"Equal to",
										"Not Equal to",
										"Contains",
										"Does not contain",
										"Begins with",
										"Ends with"
									],
									"default":["="]
								},
								"ConditionValue": {
									"title": " ",
									"type": "string"
								},
								"addBoolean": {
									"type": "boolean",
									"title": "Add Boolean Logic"
								}
							},
							"dependencies": {
								"addBoolean": {
									"oneOf": [
										{
											"properties": {
												"addBoolean": {
													"const": true
												},
												"Add": {
													"type": "string",
													"title": " ",
													"enum": [
														"and",
														"or"
													],
													"enumNames": [
														"AND",
														"OR"
													]
												}
											},
											"dependencies": {
												"Add": {
													"oneOf": [
														{
															"properties": {
																"Add": {
																	"const": "and"
																},
																"nextCondition": {
																	"$ref": "#/LastCondition/person"
																}
															}
														},
														{
															"properties": {
																"Add": {
																	"const": "or"
																},
																"nextCondition": {
																	"$ref": "#/LastCondition/person"
																}
															}
														}
													]
												}
											}
										},
										{
											"properties": {
												"addBoolean": {
													"const": false
												}
											}
										}
									]
								}
							}
						}
					}
				};

				// Dynamically generate conditional arrays
				const conditionalArrays = {};

				props.dartList.forEach((data, index) => {
					const key = `conditionalArray${index + 1}`;
					const jsonData = JSON.parse(data.param);
					const paramKeys = Object.keys(jsonData) // Parse `param` to extract keys
					const paramsId = paramKeys?.map((data: any) => jsonData[data]['pinot_column'])
					const disabledOptions = paramKeys.filter(
						(key) => jsonData[key].visibility === "disabled"
					);
					conditionalArrays[key] = {
						person: {
							title: "Select the condition",
							type: "object",
							properties: {
								"Select the asset from the dropdown": {
									type: "string",
									title: "condition",
									enum: paramsId,
									enumNames: paramKeys// Use param keys as enum values
								},
							},
							dependencies: {
								"Select the asset from the dropdown": {
									oneOf: paramsId.map((key) => ({
										properties: {
											"Select the asset from the dropdown": {
												enum: [key],
											},
											lastCondition: {
												title: " ",
												$ref: "#/LastCondition/person",
												type: "object",
												minItems: 1,
											},
										},
									})),
								},
							},
						},
						uiSchema: {
							"Select the event from the dropdown": {
								"ui:enumDisabled": paramsId.filter((id: any, idx: any) =>
									disabledOptions.includes(paramKeys[idx])
								),
							},
						},
					};
				});

				var uiValue = JSON.parse(data?.[0]?.uiSchema);
				data?.[0]?.jsonSchema !== undefined && props.setJsonData({ ...schema, ...conditionalArrays });
				data?.[0]?.uiSchema !== undefined && props.setUiData(uiValue);
			}
		} catch (error) {
			console.error("getAssetsJosnSchemaData error=", (error as Error).message);
		}
	};

	const getEventsJosnSchemaData = async () => {
		try {
			const dartId = 2004;
			const { status, data } = await apiCall('/alerts/getSchema', { dartId });

			if (data && status === 'success') {
				// Safely parse the JSON schema with error handling
				let jsonValue;
				try {
					jsonValue = data[0]?.jsonSchema ? JSON.parse(data[0].jsonSchema) : null;
				} catch (parseError) {
					console.error('Error parsing jsonSchema:', parseError);
					// Log the problematic string for debugging
					console.log('Problematic JSON string:', data[0]?.jsonSchema);
					return;
				}

				// Safely access dartList with optional chaining and type checking
				const enums = Array.isArray(props.dartList) ? props.dartList.map((data) => data.scrip) : [];
				const enumNames = Array.isArray(props.dartList) ? props.dartList.map((data) => data.description) : [];

				const schema = {
					type: "object",
					properties: {
						conditional: {
							title: "Event Field",
							items: {
								$ref: "#/definitions/person",
							},
							type: "array",
							minItems: 1,
						},
					},
					definitions: {
						person: {
							title: " ",
							properties: {
								"Select Dart Name": {
									type: "string",
									enum: enums,
									enumNames: enumNames,
								},
							},
							dependencies: {
								"Select Dart Name": {
									oneOf: props.dartList?.map((data, index) => ({
										properties: {
											"Select Dart Name": {
												enum: [data.scrip],
											},
											conditionals: {
												title: " ",
												items: {
													$ref: `#/conditionalArray${index + 1}/person`,
												},
												type: "array",
												minItems: 1,
											},
										},
									})),
								},
							},
						},
					},
					LastCondition: {},
				};

				const conditionalArrays = {};

				props.dartList?.forEach((data, index) => {
					const key = `conditionalArray${index + 1}`;

					// Safely parse the param JSON with error handling
					let jsonData;
					try {
						jsonData = JSON.parse(data.param);
					} catch (parseError) {
						console.error(`Error parsing param for index ${index}:`, parseError);
						console.log('Problematic param string:', data.param);
						return;
					}

					const paramKeys = Object.keys(jsonData);
					const paramsId = paramKeys.map((key) => jsonData[key]["pinot_column"]);
					const disabledOptions = paramKeys.filter(
						(key) => jsonData[key].visibility === "disabled"
					);

					const conditionArraysForKey = {
						person: {
							title: "Select the condition",
							type: "object",
							properties: {
								"Select the event from the dropdown": {
									type: "string",
									title: "condition",
									enum: paramsId,
									enumNames: paramKeys,
								},
							},
							dependencies: {
								"Select the event from the dropdown": {
									oneOf: paramKeys.map((param, idx) => {
										const datatype = jsonData[param]?.datatype || "String";
										const conditionOptions = {
											enum: datatype === "String"
												? ["=", "!=", "like", "not like", "like start%", "like %end"]
												: ["=", "!=", ">=", "<=", ">", "<"],
											enumNames: datatype === "String"
												? ["Equal to", "Not Equal to", "Contains", "Does not contain", "Begins with", "Ends with"]
												: ["Equal to", "Not Equal to", "Greater than or equal", "Less than or equal", "Greater than", "Less than"],
										};

										const lastConditionKey = `LastCondition_${key}_${param}`;

										if (!schema.LastCondition[lastConditionKey]) {
											schema.LastCondition[lastConditionKey] = {
												person: {
													title: " ",
													type: "object",
													properties: {
														ConditionType: {
															title: " ",
															type: "string",
															...conditionOptions,
														},
														ConditionValue: {
															title: " ",
															type: "string",
														},
														addBoolean: {
															type: "boolean",
															title: "Add Boolean Logic",
														},
													},
													dependencies: {
														addBoolean: {
															oneOf: [
																{
																	properties: {
																		addBoolean: { const: true },
																		Add: {
																			type: "string",
																			title: " ",
																			enum: ["and", "or"],
																			enumNames: ["AND", "OR"],
																		}
																	},
																	dependencies: {
																		Add: {
																			oneOf: [
																				{
																					properties: {
																						Add: { const: "and" },
																						nextCondition: {
																							$ref: `#/LastCondition/${lastConditionKey}/person`,
																						},
																					}
																				},
																				{
																					properties: {
																						Add: { const: "or" },
																						nextCondition: {
																							$ref: `#/LastCondition/${lastConditionKey}/person`,
																						},
																					}
																				}
																			]
																		}
																	},
																},
																{
																	properties: {
																		addBoolean: { const: false },
																	}
																},
															],
														},
													},
												},
											};
										}

										return {
											properties: {
												"Select the event from the dropdown": {
													enum: [paramsId[idx]],
												},
												lastCondition: {
													$ref: `#/LastCondition/${lastConditionKey}/person`,
													title: " ",
													type: "object",
												},
											},
										};
									}),
								},
							},
						},
						uiSchema: {
							"Select the event from the dropdown": {
								"ui:enumDisabled": paramsId.filter((id, idx) =>
									disabledOptions.includes(paramKeys[idx])
								),
							},
						},
					};

					conditionalArrays[key] = conditionArraysForKey;
				});

				// Safely parse the UI schema
				let uiValue;
				try {
					uiValue = data[0]?.uiSchema ? JSON.parse(data[0].uiSchema) : null;
				} catch (parseError) {
					console.error('Error parsing uiSchema:', parseError);
					console.log('Problematic UI schema string:', data[0]?.uiSchema);
					return;
				}

				if (data[0]?.jsonSchema !== undefined) {
					props.setJsonData({ ...schema, ...conditionalArrays });
				}

				if (data[0]?.uiSchema !== undefined && uiValue) {
					props.setUiData(uiValue);
				}
			}
		} catch (error) {
			console.error("getEventsJosnSchemaData error=", (error as Error).message);
		}
	};

	if (props.dartList?.length === 0) {
		fetchDartList();
	} else if (Object.keys(props.JsonData)?.length === 0) {
		props.type === 'asset' ? getAssetsJosnSchemaData() : getEventsJosnSchemaData();
	}

	
	if (props.saveBtnClicked && props.overlayOpen && props?.formData?.name?.length > 0) {
		(props.overlayName === "addAsset" || props.overlayName === "addEvent") && createAssetOrEvent(props.type, props.formData);
		(props.overlayName === 'editAsset' || props.overlayName === "editEvent") && updateAssetOrEvent(props.rowID, props.formData);
	} else if ((props.overlayName === 'editAsset' || props.overlayName === 'editEvent') && props.editBtnClicked && !props.saveBtnClicked) {
		getAssetRowDetails();
	} else if (props.deleteAsset && props.selectedRowIdInTable.length > 0) {
		deleteAssetsOrEventsData(props.selectedRowIdInTable);
	} else if (props.searchVal.length > 0 && props.searchVal !== '') {
		console.log("props.isRefresh4")
		getAssetsOrEventsList(props.type, { search: props.searchVal, function: 'search' }, 50, parseInt(props.pageNo));
		getAssetsOrEventsListCnt(props.type, { search: props.searchVal, function: 'search' });
	} else if (props.isfilter === true) {
		console.log("props.isRefresh4")
		getAssetsOrEventsList(props.type, { filter: props.filterArray, function: 'filter' }, 50, parseInt(props.pageNo));
		getAssetsOrEventsListCnt(props.type, { filter: props.filterArray, function: 'filter' });
	} else if (props.exportBtnClicked) {
		getExportData({ function: 'export', type: props.type, tenant: props.tenant });
	} else if (props.loadTableData) {
		getAssetsOrEventsList(props.type, null, 50, parseInt(props.pageNo));
		getAssetsOrEventsListCnt(props.type, null);
	}
};